interface ISiteActionButton
    extends ISiteButton {
    action?: IActionType | null;
    isFocusable?: boolean;
    key?: string;
}
interface ISiteButton {
    icon?: Icons;
    title?: string;
    color?: string;
}

class SiteButton
    extends QueryElement<HTMLElement>  {

    private _icon?: QueryElement<HTMLElement>;
    
    constructor(
        button: ISiteButton,
        registerInstance: boolean = false,
        element: HTMLElement = document.createElement("button")) {
        
        super(element, registerInstance);

        if(button.icon !== undefined) {
            this._icon = QueryElement.QueryElement("i")
                .setHtml(button.icon)
                .appendTo(this);
            if(button.color !== undefined) {
                this._icon.setAttr("style", "background-color: " + button.color)
            }
        }
        if(button.title !== undefined)
            QueryElement.QueryElement("span")
                .setHtml(button.title)
                .appendTo(this);
    }

    setIcon(icon: string) {
        this._icon?.setHtml(icon);
    }

    enable() {
        this.removeClass("disabled");
    }
    disable() {
        this.addClass("disabled");
    }
}
class SiteActionButton
    extends SiteButton
    implements ISiteFocusable {
    
    private readonly _action: SiteAction | null;
    private _actionRunning: boolean;
    private _owner: ISiteCard;

    get Action(): SiteAction | null {
        return this._action;
    }

    constructor(owner: ISiteCard, button: ISiteActionButton, element?: HTMLElement) {
        super(button, true, element);

        if(button.isFocusable !== false)
            this.setAttr("if-ISiteFocusable", "true");
        
        this._owner = owner;

        let action = SiteAction.create(owner, button.action);
        this._action = action;
        this._actionRunning = false;

        if(this._action !== null) {
            this.on("click", async () => {
                await this.onClick();
            });
        }

        if (button.key) {
            let keyCode = QueryElement.QueryElement("div")
                .addClass("key");

            for (let key of button.key.split("+")) {
                QueryElement.QueryElement("span")
                    .setHtml(key)
                    .appendTo(keyCode);
            }

            this.setAttr("data-key", button.key);
            this.append(keyCode);
        }


        this.on("keydown", (e: KeyboardEvent) => {
            switch (e.keyCode) {
                default:
                    if(e.ctrlKey)
                    {
                        owner.keyPress([17, e.keyCode]);
                        e.stop();
                    }
                    break;
                case 17: // CTRL
                    owner.keyPress([e.keyCode]);
                    e.stop();
                    break;
                case 13:
                    this.trigger("click", true);
                    e.stop();
                    break;
                case 37:
                case 38:
                    this.makePrevActive();
                case 39:
                case 40:
                case 9:
                    this.makeNextActive();
                    e.stop();
                    break;
            }
        });
    }

    async onClick() {
        if (!this._actionRunning)
        {
            this._owner.makeFocusableActive(this);

            this.trigger("actionExecuting", false);
            this._actionRunning = true;
            if(this._action)
                await this._action.execute();
            
            this._actionRunning = false;
            this.trigger("actionExecuted", false);
        }
    }

    makeActive() {
        if (this.containsClass("active"))
            return false;

        this.addClass("active");
        this.trigger("qts.active", false);
        this.focus();
        return true;
    }
    makeInactive() {
        this.removeClass("active");
        this.trigger("qts.inactive", false);
    }
    makePrevActive() {
        this._owner.makePrevFocusableActive(this);
    }
    makeNextActive() {
        this._owner.makeNextFocusableActive(this);
    }
}